import { Flex } from "@radix-ui/themes";

function ProgressContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="absolute bg-black/50 px-1.5 leading-5 rounded-md text-white text-xs bottom-4 right-4 flex flex-col items-end pointer-events-none select-none">
      {children}
    </div>
  );
}

function ProgressText({
  progress,
  title,
}: {
  progress: number | null;
  title: string;
}) {
  if (progress === null) return null;

  return (
    <Flex gap="2" align="center">
      <h1>{title}</h1>
      <p className="tabular-nums">({Math.floor(progress * 100)}%)</p>
    </Flex>
  );
}

export const LoadingProgress = {
  Root: ProgressContainer,
  Text: ProgressText,
};
